import { NgTemplateOutlet } from "@angular/common";
import {
    Component,
    ElementRef,
    OnDestroy,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import { IHeaderAngularComp } from "ag-grid-angular";
import { IconComponent } from "../../icon/icon.component";
import { RaskGridHeaderParams } from "../models/rask-grid-header-params";

@Component({
    selector: "rask-grid-header",
    templateUrl: "./grid-header.component.html",
    styleUrls: ["./grid-header.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        IconComponent,
        NgbPopover,
        NgTemplateOutlet
    ]
})
export class GridHeaderComponent implements IHeaderAngularComp, OnDestroy {
    filterActive: boolean;
    params: RaskGridHeaderParams;
    sortorder: string;

    private readonly elementRef = inject(ElementRef);

    agInit(params): void {
        this.params = params;
        if (this.params.enableSorting) {
            this.params.column.addEventListener("sortChanged", this.onSortChanged.bind(this));
            this.onSortChanged();
        }

        this.params.column.addEventListener("filterChanged", this.onFilterChanged.bind(this));
    }

    ngOnDestroy(): void {
        this.params.column.removeEventListener(
            "sortChanged",
            this.onSortChanged
        );

        this.params.column.removeEventListener(
            "filterChanged",
            this.onFilterChanged
        );
    }

    onMenuClick(): void {
        if (this.params.enableMenu) {
            this.params.showColumnMenu(this.querySelector(".ag-header-cell-menu-button"));
        }
    }

    onSortRequested(event): void {
        if (this.params.enableSorting) {
            this.params.progressSort(false);
        }
    }

    refresh(params): boolean {
        return true;
    }

    private onFilterChanged(): void {
        this.filterActive = this.params.column.isFilterActive();
    }

    private onSortChanged(): void {
        if (this.params.column.getSort() === "asc") {
            this.sortorder = "asc";
        } else if (this.params.column.getSort() === "desc") {
            this.sortorder = "desc";
        } else {
            this.sortorder = undefined;
        }
    }

    private querySelector(selector: string): HTMLElement {
        return this.elementRef.nativeElement.querySelector(
            ".ag-header-cell-menu-button", selector) as HTMLElement;
    }
}
